import { StoreState } from '@deqo/foundation';
import { injectable } from 'inversify';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { AppEvents } from '../AppEvents';
import { resolve } from '../Container';
import { PreferencesModel } from '../preferences/PreferencesModel';

// TODO: This is bad, improve this at some point

@injectable()
export class PreferencesManager {

    @resolve(ApiClient) private api: ApiClient;
    @resolve(AppEvents) private events: AppEvents;

    public async patch(changes: Partial<StoreState<PreferencesModel>>) {
        await this.api.exec(v2.me.preferences.update(changes));
    }
}
